import { useTranslation } from "react-i18next";
import { DashboardTile } from "@idwal/idwal-react-components";
import { GradeMetrics } from "../../types/Metric";
import { useMemo, useCallback } from "react";
import { openUrl } from "../../services/WindowOpenService";
import { sendGAEvent } from "../../AnalyticsService";
import { DASHBOARD_CATEGORY, DASHBOARD_MOST_IMPROVED_GRADE_KPI_CLICK, DASHBOARD_LEAST_IMPROVED_GRADE_KPI_CLICK } from "../../constants/analytics";

type Props = {
    metrics: GradeMetrics | undefined;
    loading: boolean;
};

export const ImprovedGradeTiles = (props: Props) => {
    const { metrics, loading } = props;

    const { t } = useTranslation("locale");

    const elements = useMemo(
        () => ({
            link: true,
            tooltip: false,
            colourBar: true,
            trend: true,
            label: true,
            button: false
        }),
        []
    );

    const onMostClick = useCallback(() => {
        sendGAEvent(DASHBOARD_CATEGORY, DASHBOARD_MOST_IMPROVED_GRADE_KPI_CLICK);
        openUrl(`${process.env.REACT_APP_ID_PLATFORM_CUSTOMER_REPORT_URL_ROOT}/Inspection/${metrics?.most_improved?.inspection_id}`);
    }, [metrics]);

    const onLeastClick = useCallback(() => {
        sendGAEvent(DASHBOARD_CATEGORY, DASHBOARD_LEAST_IMPROVED_GRADE_KPI_CLICK);
        openUrl(`${process.env.REACT_APP_ID_PLATFORM_CUSTOMER_REPORT_URL_ROOT}/Inspection/${metrics?.least_improved?.inspection_id}`);
    }, [metrics]);

    const tiles = useMemo(
        () => [
            {
                metric: t("dashboard.mostImprovedIdwalGrade"),
                value: metrics?.most_improved?.value,
                unit: `${metrics?.most_improved?.ship_name} (${metrics?.most_improved?.imo})`,
                label: t("dashboard.fromPreviousInspection"),
                trendValue: `+${metrics?.most_improved?.improvement}`,
                trendType: "positiveUp",
                onClick: onMostClick,
            },
            {
                metric: t("dashboard.leastImprovedIdwalGrade"),
                value: metrics?.least_improved?.value,
                unit: `${metrics?.least_improved?.ship_name} (${metrics?.least_improved?.imo})`,
                label: t("dashboard.fromPreviousInspection"),
                trendValue: `+${metrics?.least_improved?.improvement}`,
                trendType: "positiveUp",
                onClick: onLeastClick,
            },
        ],
        [metrics, onMostClick, onLeastClick]
    );

    if (!metrics && !loading) {
        return (
            <div className="flex justify-content-center">
                <p>{t("dashboard.noDashboardAvailable")}</p>
            </div>
        );
    }

    return (
        <>
            {tiles.map((tile, index) => (
                <div className="col-12 md:col-6">
                    <DashboardTile
                        key={index}
                        loading={loading}
                        data={tile}
                        elements={elements}
                    />
                </div>
            ))}
        </>
    );
};
